<template>
  <div class="zbtList-box">
    <!-- 扎比特饰品列表 -->

    <!-- 搜索 -->
    <el-row style="margin-bottom: 20px">
      <el-select
        style="width: 150px; margin-right: 20px"
        size="small"
        v-model="query.prizeType"
        placeholder="奖品分类"
        @change="getData(1)"
      >
        <el-option :value="1" label="csgo"></el-option>
        <el-option :value="5" label="dota"></el-option>
      </el-select>
      <el-input
        style="width: 200px; margin-right: 20px"
        size="small"
        placeholder="商品名称搜索"
        v-model="query.keyword"
      ></el-input>
      <!-- <el-select
        style="width: 120px; margin-right: 20px"
        v-model="query.appearanceValue"
        placeholder="外观"
        size="small"
      >
        <el-option :value="undefined">不限</el-option>
        <el-option
          v-for="item in staticData.appearance"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
      <el-button
        style="margin-right: 20px"
        size="small"
        type="primary"
        @click="getData(1)"
        >搜索</el-button
      >
      <!-- <span class="pull-right">扎比特余额: {{ 123456 }}</span> -->
    </el-row>
    <!-- 列表 -->
    <div class="prize-list-wrap" v-loading="loadingZbtPrize">
      <ul class="prize-list" v-if="zbtPrizeList && zbtPrizeList.length > 0">
        <li class="prize-item" v-for="item in zbtPrizeList" :key="item.itemId">
          <i
            class="buyIcon el-icon-view"
            title="查看在售列表"
            @click="showzbtSell(item)"
          ></i>
          <div class="prize_img">
            <img :src="item.imageUrl" alt />
          </div>
          <p>
            <span>{{ item.itemName }}</span>
          </p>
          <p>
            <span>{{ item.marketHashName }}</span>
          </p>
          <p class="price-box">
            <span
              :style="`color: ${
                query.prizeType === 1 ? item.qualityColor : item.rarityColor
              };`"
              >{{
                query.prizeType === 1 ? item.qualityName : item.rarityName
              }}</span
            >
            <span class="price"
              >{{ item.priceInfo ? item.priceInfo.price : "" }} T币</span
            >
          </p>
          <p>数量：{{ item.priceInfo ? item.priceInfo.quantity : "" }}</p>
        </li>
      </ul>
      <p
        class="null_tips"
        style="text-align: center; line-height: 100px"
        v-else
      >
        暂无数据
      </p>
    </div>
    <!-- 底部分页条 -->
    <el-pagination
      class="underBar"
      background
      :page-size="zbtPrizeMeta.per_page || 20"
      :total="zbtPrizeMeta.total || 0"
      :current-page="zbtPrizeMeta.current_page || 1"
      @current-change="handleZBTPageChange"
      v-if="zbtPrizeMeta && zbtPrizeMeta.total > zbtPrizeMeta.per_page"
    ></el-pagination>

    <!--扎比特商品在售列表-->
    <el-dialog
      class="dialog-box"
      :visible.sync="zbtSellProductVisible"
      title="扎比特商品在售列表"
      :close-on-click-modal="false"
      width="1000px"
      @close="closeZbtSellDialog"
      append-to-body
    >
      <div class="prize-list-wrap" v-loading="loadingZbtSellProduct">
        <ul
          class="prize-list"
          v-if="zbtSellProductList && zbtSellProductList.length > 0"
        >
          <li
            class="prize-item"
            v-for="sellerInfo in zbtSellProductList"
            :key="sellerInfo.id"
            style="width: 140px"
          >
            <div v-if="infos" class="buyIcon">
              <i
                v-if="!buyLock || buyGoodsId != sellerInfo.id"
                class="el-icon-wallet"
                title="购买物品"
                @click="zbtDeliver(sellerInfo)"
              ></i>
              <i v-else class="el-icon-loading" title="正在请求中..."></i>
            </div>
            <div v-else class="addIcon">
              <i
                class="el-icon-plus"
                title="选择物品"
                @click="addZBTGoods(sellerInfo)"
              ></i>
            </div>

            <div class="prize_img">
              <img :src="sellerInfo.imageUrl" alt />
            </div>
            <p>
              <span>{{ sellerInfo.itemName }}</span>
            </p>
            <p>
              <span
                >发货类型:{{
                  sellerInfo.delivery === 1 ? "手动发货" : "自动发货"
                }}</span
              >
            </p>
            <p class="price-box" style="font-size: 13px">
              <span>{{ sellerInfo.cnyPriceTrue }}元</span>
              <span class="price">{{ sellerInfo.price }} T币</span>
            </p>
          </li>
        </ul>
        <p
          class="null_tips"
          style="text-align: center; line-height: 100px"
          v-else
        >
          暂无数据
        </p>
      </div>
      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="zbtSellProductMeta.per_page || 10"
        :total="zbtSellProductMeta.total || 0"
        :current-page="zbtSellProductMeta.current_page || 1"
        @current-change="handleZBTSellPageChange"
        v-if="
          zbtSellProductMeta &&
          zbtSellProductMeta.total > zbtSellProductMeta.per_page
        "
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, { patchData, server, postApiData, getApiData } from '@/http'
// import appearance from '@/assets/js/appearance'
// import mallUnique from '@/assets/js/mallUnique'
// import mallQuality from '@/assets/js/mallQuality'
// import mallClassification from '@/assets/js/mallClassification'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      zbtSellProductVisible: false, //扎比特在售列表弹窗显示标志
      loading: false, //加载动画
      loadingZbtPrize: false, //zbt列表加载动画
      loadingZbtSellProduct: false, //zbt在售列表加载动画
      buttonLoading: false,//按钮加载动画
      buyLock: false,//防止购买重复点击锁
      buyGoodsId: undefined,//当前被购买物品的id
      query: {
        page: 1,//页数
        prizeType: 1,//奖品分类 1是csgo 5是dota2 ,默认是1
        keyword: undefined, //物品名称
        // appearanceValue: undefined, //外观
      },
      zbtSellquery: {
        page: 1,
        itemId: ''
      },
      staticData: {//引入外部的js静态数据
        // appearance: appearance,//物品外观/磨损度
        // mallUnique: mallUnique,//商城物品暗金
        // mallQuality: mallQuality,//商城物品品质
        // mallClassification: mallClassification,//商城物品种类
      },
      zbtPrizeList: undefined,//扎比特物品列表,
      zbtSellProductList: undefined,//扎比特在售物品列表
      zbtPrizeMeta: undefined, //扎比特物品底部跳转页面数据
      zbtSellProductMeta: undefined, //扎比特在售物品底部跳转页面数据
    }
  },
  computed: {
    ...mapState({
      boxCategories: (state) => state.data.boxCategories, //箱子分类数据
    }),
    infos: {
      get() {
        //拿到要查询的物品名字
        return this.value
      },
      set() { }
    }
  },
  watch: {
    infos: {
      // 监听传来的订单数据
      immediate: true, //监听首次
      handler: function (val) {
        //执行代码
        if (!val) {
          //不是购买物品而是选择物品时，不会传参进来，就直接查数据
          this.getData()//查询数据
        } else {
          this.query.keyword = val.shop_prize.name
          this.getData()//查询数据
        }
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    getData(num) {
      //获取zbt物品列表
      this.loadingZbtPrize = true
      if (num) {
        //当搜索新东西而不是底部换页时，还原页面下标为1
        this.query.page = 1
      }

      // let params = {
      //   third_type: "zbt",
      //   query: {
      //     page: this.query.page,
      //     keyword: this.query.keyword,
      //     // appearanceValue: this.query.appearanceValue,
      //     app_id: this.query.prizeType === 1 ? 730 : 570
      //   }
      // }
      let params = {
        app_id: this.query.prizeType === 1 ? 730 : 570,
        keyword: this.query.keyword,
        page: this.query.page,
      }
      getApiData('zbt/search', params).then(res => {
        if (res) {
          this.zbtPrizeList = res.list
          //设置底部导航条数据
          this.zbtPrizeMeta = {
            current_page: res.page, //当前页标
            per_page: res.page_size, //每页多少条
            total: res.total, //总数据条数
            total_pages: res.total_pages, //总页数
          }
        }
      }).finally(() => {
        this.loadingZbtPrize = false
      })
    },
    showzbtSell(itemInfo) {
      //打开扎比特在售列表弹窗
      this.zbtSellProductVisible = true
      //绑定物品id
      this.zbtSellquery.itemId = itemInfo.itemId
      this.getZbtSellProduct(itemInfo)
    },
    getZbtSellProduct(infos) {
      //获取扎比特在售列表数据
      this.loadingZbtSellProduct = true
      let params = this.zbtSellquery
      getApiData('zbt/sell_product', params)
        .then(res => {
          //给在售列表所有数据都加上物品的原名字，不加磨损度的原名字
          // for (let i = 0; i < res.data.data.length; i++) {
          //   if (res.data.data[i]) {
          //     res.data.data[i].shortName = infos.shortName
          //   }
          // }
          this.zbtSellProductList = res.list
          //设置底部导航条数据
          this.zbtSellProductMeta = {
            current_page: res.page, //当前页标
            per_page: res.page_size, //每页多少条
            total: res.total, //总数据条数
            total_pages: res.pages, //总页数
          }
        })
        .finally(() => {
          this.loadingZbtSellProduct = false
        })
    },
    zbtDeliver(itemInfo) {
      //购买扎比特商品
      if (this.buyLock) {
        //防止重复点击的锁
        this.$message.error("请求正在进行中，请勿重复点击")
        return
      }
      this.buyGoodsId = itemInfo.id//保存当前正在购买的物品的id
      this.buyLock = true//加锁
      let params = {
        productId: itemInfo.id,
        buyPrice: itemInfo.sellerPrice,
        delivery: itemInfo.delivery
      }
      postApiData('zbt/buy/' + this.infos.id, params)
        .then(res => {
          this.$message.success('购买成功')
          this.closeZbtSellDialog() //关闭zbt在售列表弹窗
          this.closeThirdDialig()//关闭第三方物品弹窗
          // this.$emit("refresh")//刷新列表
          this.buyLock = false//解锁
        }).catch(error => {
          this.buyLock = false//解锁
        })
    },
    addZBTGoods(infos) {
      //添加扎比特商品
      //处理数据格式 1是csgo 5是dota
      let Info = {}
      if (this.query.prizeType === 1) {
        // cago物品属性
        Info = {
          id: infos.itemId,//物品id
          price: infos.cnyPriceTrue,//物品价格
          image: infos.imageUrl,//物品图片
          completeName: infos.itemName,//带磨损度的完整名称
          name: infos.shortName,//不带磨损度的名称
          market_hash_name: infos.marketHashName,//英文名
          secondName: infos.itemInfo.exteriorName,//物品磨损度
          qualityName: infos.itemInfo.qualityName,//物品的暗金
          rarityName: infos.itemInfo.rarityName,//物品品质
          typeName: infos.itemInfo.typeName,//物品品质的探员的类型/物品种类一级类别
          weaponName: infos.itemInfo.weaponName,//物品种类（完整的种类是由typeName加上weaponName）
          prize_form: 1, //记录来源 1表示扎比特 2表示IG 3代表机器人
          prize_type: this.query.prizeType, //物品种类 1csgo 5表示dota
        }
      } else {
        // dota物品属性
        Info = {
          id: infos.itemId,//物品id
          price: infos.cnyPriceTrue,//物品价格
          image: infos.imageUrl,//物品图片
          name: infos.itemName,//物品名称
          market_hash_name: infos.marketHashName,//英文名
          rarityName: infos.itemInfo.rarityName,//物品稀有度
          prize_form: 1, //记录来源 1表示扎比特 2表示IG 3代表机器人
          prize_type: this.query.prizeType, //物品种类 1csgo 5表示dota
        }
      }

      this.$emit('callbackInfo', Info)
      this.closeZbtSellDialog() //关闭zbt在售列表弹窗
      this.closeThirdDialig()//关闭第三方物品弹窗
    },
    closeZbtSellDialog() {
      //关闭扎比特商品在售列表
      this.zbtSellProductVisible = false
      this.zbtSellquery.page = 1
      // this.zbtSellProductMeta = {}
      // this.zbtSellProductList = []
    },
    closeThirdDialig() {
      //关闭第三方物品弹窗
      this.$emit("close")
      this.query.page = 1
      // this.zbtPrizeMeta={}
      // this.zbtPrizeList=[]
    },
    handleZBTPageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    handleZBTSellPageChange(page) {
      //页面底部跳转页面
      this.zbtSellquery.page = page
      this.getZbtSellProduct();
    },
  }

}

</script>
<style lang="less" scoped>
.zbtList-box {
}
</style>
